<template>
  <section id="relic-detail-plain">
    <edit-header-vue
      title="规划信息"
      v-model="visibleEdit"
      @onSaveClick="handleSavePlain"
      @onCancelClick="handleCancelPlain"
    />

    <!-- 内容容器 -->
    <div class="plain-container">
      <!-- 左侧，信息字段为主 -->
      <div class="plain-content plain-content--left">
        <div class="plain-content--left__box">
          <file-uploader-ctrl
            class="plain-upload plain-upload--text"
            action=""
            v-if="limitShow"
            fileAccept=".pdf"
            :filePath="filePath"
            :fileSize="100"
            :customName="
              `${gettersRelicDetail.relicFromUserId}_${gettersRelicDetail.relicName}.pdf`
            "
            @onUploadSuccess="uploadingRelicPDF"
          >
            <div type="text" class="plain-upload__btn">
              上传规划文本
            </div>
          </file-uploader-ctrl>
          <!-- <div>预览</div> -->
          <a
            class="plain-upload__btn"
            style="margin-left:10px"
            v-if="gettersRelicDetail.planningPdf"
            :href="gettersRelicDetail.planningPdf"
            target="_blank"
            rel="noopener noreferrer"
            >预览</a
          >
          <div
            v-if="gettersRelicDetail.planningPdf"
            @click="deleteRelicPDFClick"
            style="margin-left:10px"
            type="text"
            class="plain-upload__btn"
          >
            删除
          </div>
        </div>
        <div class="plain-upload plain-upload--text" v-if="!limitShow"></div>
        <edit-input-vue
          v-model="modelValue[info.value]"
          v-for="(info, index) in relicPlainInfo"
          :key="index"
          :edit="visibleEdit"
          :label="info.label"
          :placeholder="info.placeholder"
          :options="info.options || {}"
        >
          <template v-if="info.slot && limitShow" v-slot:append
            ><div
              class="plain-coodrnate"
              @click="handleWgsToCgcsDialog(info.appendValue)"
              :class="{ 'disabled-edit': !visibleEdit }"
            >
              {{ info.text }}
            </div></template
          >
        </edit-input-vue>
      </div>
    </div>
    <gis-list-create-vue
      v-model="showCreateGis"
      v-if="showCreateGis"
      :cgcsParam="cgcsParam"
      :type="coodrType"
      @onComfirmPolygons="handleConfirmTransform"
    />
  </section>
</template>

<script>
import { updateRelicPlan, uploadingRelicPDF } from '../../api/index';
import editHeaderVue from '../layout/edit-header.vue';
import editInputVue from '../layout/edit-input.vue';
import { mapActions, mapGetters } from 'vuex';
import gisListCreateVue from '../gis/gis-list-create.vue';
import FileUploaderCtrl from '../layout/file-uploader-ctrl.vue';
import { modelMixin } from '../../assets/js/mixins/model';
function transformArea(data) {
  if (!data) {
    return data;
  }
  if (data.includes('平方米')) {
    return data;
  } else {
    return data + '平方米';
  }
}
export default {
  name: 'RelicDetailPlain',
  mixins: [modelMixin],
  components: {
    editHeaderVue,
    editInputVue,
    gisListCreateVue,
    FileUploaderCtrl
  },
  computed: {
    ...mapGetters('relic', ['gettersRelicDetail']),
    ...mapGetters('login', ['limitShow']),
    filePath() {
      return `relic/${this.gettersRelicDetail.relicAutoIncrementId}/pdf`;
    }
  },
  data() {
    return {
      coodrType: '',
      showCreateGis: false,
      client: null,
      visibleEdit: false, // 控制编辑状态显示
      cgcsParam: '',
      relicPlainInfo: [
        {
          label: '保护范围面积：',
          slot: false,
          text: '保护范围坐标',
          appendValue: 'protectCgcs',
          value: 'protectArea',
          placeholder: '单位为平方米'
        },
        {
          label: '保护范围要求：',
          value: 'protectRequirement',
          options: {
            type: 'textarea'
          }
        },
        {
          label: '建控地带面积：',
          text: '建控范围坐标',
          appendValue: 'controlCgcs',
          slot: false,
          value: 'controlArea',
          placeholder: '单位为平方米'
        },
        {
          label: '建控地带保护要求：',
          value: 'controlRequirement',
          options: {
            type: 'textarea'
          }
        }
      ] // 规划信息
    };
  },

  methods: {
    /**
     * 显示转换窗口
     */
    handleWgsToCgcsDialog(param) {
      if (this.visibleEdit) {
        //
        // console.log(param);
        this.cgcsParam = this.modelValue[param];
        //
        this.coodrType = param;
        this.showCreateGis = true;
      }
    },

    /**
     * 初始化建筑信息
     */
    async initRelic() {
      await this.getBaseRelicInfo(this.modelValue.relicAutoIncrementId);
      this.visibleEdit = false;
    },

    /**
     * 更新建筑规划信息
     */
    async handleSavePlain() {
      // if(this.relicPlainInfo.every(e=>{
      //   return e.value
      // })){
      const params = Object.assign({}, this.modelValue);
      await updateRelicPlan(params);
      await this.initRelic();
      this.$prompt('修改成功');
    },

    /**
     * 取消规划信息
     */
    async handleCancelPlain() {
      await this.initRelic();
    },

    /**
     * 删除规划文本
     */
    async deleteRelicPDFClick() {
      await uploadingRelicPDF({
        relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId,
        pdfUrl: ''
      });
      this.$prompt('删除成功');
      this.initRelic();
    },

    /**
     * 上传pdf
     */
    uploadingRelicPDF(url) {
      uploadingRelicPDF({
        relicAutoIncrementId: this.gettersRelicDetail.relicAutoIncrementId,
        pdfUrl: url
      })
        .then(res => {
          if (res.data.code == 200) {
            this.$prompt('上传成功');
            this.initRelic();
            // this.$emit('onSuccessEditPlain');
          } else {
            this.$prompt('上传失败');
          }
        })
        .catch(e => {
          this.$prompt('上传失败');
        });
    },
    /**
     * 监听坐标转换回调
     */
    handleConfirmTransform(polygons, polygonString, amapStr, type) {
      // console.log(polygons, polygonString, amapStr, type);
      this.showCreateGis = false;
      this.$prompt('坐标转换成功');
      if (type == 'controlCgcs') {
        this.modelValue.controlCgcs = polygonString;
        this.modelValue.controlCoordinate = amapStr;
      } else {
        this.modelValue.protectCgcs = polygonString;
        this.modelValue.protectCoordinate = amapStr;
      }
    },

    ...mapActions('relic', ['getBaseRelicInfo'])
  }
};
</script>

<style lang="scss">
#relic-detail-plain {
  margin-top: 46px;
  .disabled-edit {
    cursor: not-allowed !important;
  }
  .plain {
    &-container {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-top: 35px;
    }
    &-coodrnate {
      border-bottom: 1px solid $color-primary;
      color: $color-primary;
      font-size: 14px;
      line-height: 1em;
      cursor: pointer;
      margin-left: 40px;
    }
    &-content {
      &--left {
        &__box {
          display: flex;
          padding-bottom: 25px;
        }
        .edit-input {
          &__label {
            width: 110px;
          }
        }
      }
      &--right {
        width: 370px;
      }
    }
    &-upload {
      position: relative;
      &__btn {
        font-size: 14px;
        color: $color-primary;
        border-bottom: 1px solid $color-primary;
      }
      &__file {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
      }
    }
  }
}
</style>
